import { MouseEvent, ReactNode } from 'react';

export interface IBottomServiceModeProps {}

export interface IBottomServiceModeDetail {
  heading: string;
  details: string;
  icon: ReactNode;
  buttonContentText: string;
  buttonContentIcon: ReactNode;
  onButtonClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  onBottomServiceClick?: () => void;
  buttonDisabled?: boolean;
  variant?: BottomServiceVariants;
}

export interface IBottomServiceModeViewProps extends IBottomServiceModeDetail {
  isLoading?: boolean;
  className?: string;
}

export enum BottomServiceVariants {
  DEFAULT,
  IN_PROGRESS
}
